import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { formatErr } from "../lib/auth";
import { Shield, ArrowRight, Mail, Check } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(formatErr(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="section hero-radial min-h-[85vh] flex items-center">
      <div className="container-if max-w-md mx-auto">
        <div className="card-dark p-9">
          <div className="flex items-center gap-2 mb-6">
            <Shield className="w-5 h-5 text-[var(--if-gold)]" strokeWidth={1.5} />
            <span className="font-mono-label text-[var(--if-gold)]">Password Reset</span>
          </div>
          {sent ? (
            <>
              <div className="w-12 h-12 rounded-full bg-[var(--if-gold)]/20 flex items-center justify-center mb-5">
                <Check className="w-6 h-6 text-[var(--if-gold)]" />
              </div>
              <h1 className="font-display text-3xl mb-3">Check your inbox.</h1>
              <p className="text-sm text-white/60 mb-6" style={{ fontFamily: "Inter, sans-serif" }}>
                If an account exists for <strong className="text-white">{email}</strong>, we've sent a reset link. It expires in 1 hour.
              </p>
              <Link to="/login" className="btn-outline w-full" data-testid="fp-back-login">Back to sign-in</Link>
            </>
          ) : (
            <>
              <h1 className="font-display text-3xl mb-2">Forgot your password?</h1>
              <p className="text-sm text-white/60 mb-8" style={{ fontFamily: "Inter, sans-serif" }}>
                Enter your email and we'll send you a link to reset it.
              </p>
              <form onSubmit={submit} className="flex flex-col gap-3">
                <input
                  required
                  type="email"
                  className="if-input"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="fp-email"
                />
                {err && <div className="text-red-400 text-sm">{err}</div>}
                <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="fp-submit">
                  {loading ? "Sending…" : <>Send reset link <ArrowRight className="w-4 h-4" /></>}
                </button>
              </form>
              <div className="divider-gold my-6" />
              <p className="text-sm text-center text-white/60" style={{ fontFamily: "Inter, sans-serif" }}>
                Remembered it? <Link to="/login" className="text-[var(--if-gold)] underline">Sign in</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
